<template lang="pug">
.d-flex.flex-column.gap-8.text-body-1.text-justify
  p
    | В соответствии с требованием статьи 9 Федерального закона от 27.07.2006 г.
    |  №152-ФЗ «О персональных данных» в целях организации моего участия в мероприятии
    |  "{{ event.name }}" предоставляю согласие
    template(v-if="!event.isManyLevels")
      |  оператору персональных данных
      |  "{{ event.organization.full_name }}" (ИНН:
      |  {{ event.organization.inn }}, юридический адрес: {{ event.organization.legal_address }})
    template(v-else)
      |  указанным ниже операторам персональных данных
    |  на осуществление обработки следующих своих (либо лица родителем
    |  (законным представителем) которого я являюсь) персональных данных:
  ul
    li Номер сертификата ПФДО
    template(v-for="(field, index) in fieldsNames")
      li(:key="index") {{ field }}
  template(v-if="event.isManyLevels")
    p
      | Согласие дано следующим операторам персональных данных, осуществляющим организацию указанного мероприятия:
    ul
      template(v-for="(org, index) in event.organizers")
        li(:key="index") "{{ org.full_name }}" (ИНН: {{ org.inn }}, юридический адрес: {{ org.legal_address }})
  p
    | Предоставляю право осуществлять обработку с использованием средств
    |  автоматизации или без использования таких средств, включая сбор, запись,
    |  систематизацию, накопление, хранение, уточнение (обновление, изменение),
    |  извлечение, использование, обезличивание, блокирование, удаление, уничтожение
    |  персональных данных в целях, определенных настоящим согласием.
    |  Данное Согласие действует с момента подписания и до истечения сроков, установленных
    |  действующим законодательством Российской Федерации, а также может быть отозвано
    |  по письменному заявлению.
</template>

<script>
export default {
  name: 'EventAgreementInfo',
  components: {},
  props: {
    fieldsNames: {
      type: Array,
      default: () => [],
    },
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
